import { render } from "./relaxation.vue?vue&type=template&id=11c3b91a"
import script from "./relaxation.vue?vue&type=script&lang=js"
export * from "./relaxation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__